import * as serverRenderingUtils from '../../../helpers/serverRenderingUtils';
import { getEpochTime } from '../Date';
import { DateRange } from '../Date/types';

type ParameterValue = string | number | boolean | Date | null | undefined;
type QueryParameters = {
  [key: string]: ParameterValue;
  startDateRange?: Date | null;
  endDateRange?: Date | null;
};

export function getApiUrl({
  path,
  queryParameters,
  isWebEndpoint,
}: {
  path: string;
  queryParameters?: QueryParameters;
  isWebEndpoint?: boolean;
}) {
  const queryParameterString = queryParameters
    ? `${getQueryParameters(queryParameters)}`
    : '';
  const baseUrl = isWebEndpoint ? '/api' : '/api/proxy/v3';
  return `${baseUrl}/${path}${queryParameterString}`;
}

function getQueryParameters(queryParameters: QueryParameters) {
  const keys = Object.keys(queryParameters);
  if (keys.length === 0) return '';
  return keys.reduce((acc, key) => {
    const value = queryParameters[key];
    if (value) {
      return `${acc}${getNewParameter(key, value)}&`;
    }
    return acc;
  }, '?');
}

function getNewParameter(key: string, value: ParameterValue) {
  switch (key) {
    case 'startDateRange':
      return `timeRangeStart=${getEpochTime(value as Date)}`;
    case 'endDateRange':
      return `timeRangeEnd=${getEpochTime(value as Date)}`;
    default:
      return `${key}=${value}`;
  }
}

export function getCsvFilename({
  baseName,
  startDateRange,
  endDateRange,
}: DateRange & {
  baseName: string;
}) {
  function formatDate(date: Date) {
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
  }
  const dateRangeString =
    startDateRange && endDateRange
      ? `_${formatDate(startDateRange)}--${formatDate(endDateRange)}`
      : '_all-time';
  return `${baseName}${dateRangeString}.csv`;
}

export function getIsValidUrl(url: string) {
  // https://www.regextester.com/93652
  return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]+(:[0-9]{1,5})?(\/.*)?$/.test(
    url
  );
}

export function getOrigin() {
  return serverRenderingUtils.windowUndefined()
    ? 'https://anchor.fm'
    : window.location.origin;
}
